import { useEffect, useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { adminApi, AdminClient } from '../api/admin';

export default function AdminClients() {
  const { getToken } = useAuth();
  const [clients, setClients] = useState<AdminClient[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [slug, setSlug] = useState('');
  const [name, setName] = useState('');
  const [creating, setCreating] = useState(false);

  const load = async () => {
    try {
      const t = await getToken();
      setClients(await adminApi.listClients(t));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  useEffect(() => { load(); /* eslint-disable-line react-hooks/exhaustive-deps */ }, []);

  const create = async (e: FormEvent) => {
    e.preventDefault();
    setCreating(true); setError(null);
    try {
      const t = await getToken();
      await adminApi.createClient(t, { slug, name });
      setSlug(''); setName('');
      await load();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setCreating(false);
    }
  };

  return (
    <div>
      <h1 style={{ color: 'var(--mi-navy)' }}>Clients</h1>
      {error && <div style={{ background: '#fee', padding: 12, borderRadius: 6, marginBottom: 12 }}>{error}</div>}

      <form onSubmit={create} className="card" style={{ marginBottom: 16, display: 'grid', gap: 8, gridTemplateColumns: '1fr 2fr auto' }}>
        <input
          placeholder="slug (e.g. acme)"
          value={slug}
          onChange={(e) => setSlug(e.target.value.toLowerCase())}
          pattern="[a-z0-9][a-z0-9-]{1,63}"
          required
          style={inputStyle}
        />
        <input
          placeholder="Client name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" className="btn-primary" disabled={creating}>
          {creating ? 'Creating…' : 'Create client'}
        </button>
      </form>

      {!clients ? (
        <div>Loading…</div>
      ) : clients.length === 0 ? (
        <div className="card">No clients yet.</div>
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Slug</th>
              <th style={thStyle}>Created</th>
              <th style={thStyle}></th>
              <th style={thStyle}></th>
            </tr>
          </thead>
          <tbody>
            {clients.map((c) => (
              <tr key={c.id}>
                <td style={tdStyle}>{c.name}</td>
                <td style={tdStyle}><code>{c.slug}</code></td>
                <td style={tdStyle}>{new Date(c.created_at).toLocaleDateString()}</td>
                <td style={tdStyle}>
                  <Link to={`/admin/clients/${c.id}?slug=${encodeURIComponent(c.slug)}`}>Settings →</Link>
                </td>
                <td style={tdStyle}>
                  <a href={`/${c.slug}`} target="_blank" rel="noopener noreferrer">Open portal ↗</a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const inputStyle: React.CSSProperties = { padding: '0.5rem', borderRadius: 6, border: '1px solid var(--mi-border)' };
const tableStyle: React.CSSProperties = { width: '100%', borderCollapse: 'collapse', background: 'var(--mi-surface)', borderRadius: 8, overflow: 'hidden', border: '1px solid var(--mi-border)' };
const thStyle: React.CSSProperties = { textAlign: 'left', padding: '10px 12px', background: '#f1f3f5', borderBottom: '1px solid var(--mi-border)', fontSize: 13 };
const tdStyle: React.CSSProperties = { padding: '10px 12px', borderBottom: '1px solid var(--mi-border)' };
